import { Route, Routes } from "react-router-dom";
import RouterData from "./routerData";

const Router = () => {
    const pageRoutes = RouterData.map(({ path, title, element }) => {
      return <Route key={title} path={`${path}`} element={element} />;
    });
  
    return <Routes>{pageRoutes}</Routes>;
  };
  
  export default Router;